<template>
	<div class="d-flex align-center my-2">
		<avatar :user="user" :size="35" class="mr-1" />

		<div class="d-flex flex-column mx-2">
			<span class="subtitle-2 font-weight-bold text-black">
				{{ user ? user.name : "" }}</span
			>
			<span class="text-left caption font-weight-medium text-grey">
				{{ user ? (user.team ? user.team.name : "") : "" }}
			</span>
		</div>
	</div>
</template>

<script>
import Avatar from "@/components/Avatar";

export default {
	components: {
		Avatar,
	},

	props: {
		user: Object,
	},
};
</script>
